import React from 'react';
import {getComponent} from '../algorithmsSettings/algorithmsSettings';
import { Spin, Space } from 'antd';

class AlgorithmsDetails extends React.Component {

    state = {
        data: [],
        algorithmId: '',
        map: [],
        tempDataResult: [],
        elementArray: [],
    };

    getMap = (arr) => {
        let result = [];
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].logicBlock.length; j++) {
                for (let k = 0; k < arr[i].logicBlock[j].rules.length; k++) {
                    result.push({"index": i, "elem": [arr[i].logicBlock[j].rules[k].elementId]})
                }
            }
        }
        for (let i = 0; i < result.length - 1; i++) {
            if (result[i].index === result[i + 1].index) {
                result[i].elem = [result[i].elem[0], result[i + 1].elem[0]];
                result.splice(i + 1, 1)
            }
        }
        this.setState({map: result});
    };

    async componentDidMount() {
        await fetch(`${window.location.origin}/wp-json/webalgos/getalgo?password=wildgeese&id=${window.webalgo_json}`)
        // await fetch(`http://karat-expert.ru/wp-json/webalgos/getalgo?password=wildgeese&id=1790`)
            .then(res => res.json())
            .then(res => this.setState({data: JSON.parse(res.data)}))
        this.getMap(this.state.data);
        console.log('new')
    }

    tempDataResultHandler = async (elementId) => {
        let tempData = this.state.map.map(item => {
                for (let i = 0; i < item.elem.length; i++) {
                    if ((item.elem[i] === elementId) || (item.elem[i] === 0)) {
                        return item.index
                    }
                }
            }
        );
        let tempDataResult = [];
        for (let i = 0; i < tempData.length; i++) {
            if (tempData[i] !== undefined && tempData[i + 1] !== tempData[i]) {
                tempDataResult.push(tempData[i])
            }
        }
        await this.setState({tempDataResult: tempDataResult})
    };

    changeCheckedData = (elementId, value, valueId, item, componentBlock) => {
        const changeData = [];
        if (componentBlock.type === 'radiobutton') {
            this.state.data.map(component => {
                if (component.id === elementId) {
                    component.content.value.forEach(itemValue => {
                        if (itemValue.key === valueId && itemValue.checked !== true) {
                            itemValue.checked = value
                        } else if (itemValue.checked !== false) {
                            itemValue.checked = !value
                        }
                    })
                }
                return changeData.push(component)
            });
        } else {
            this.state.data.map(component => {
                if (component.id === elementId) {
                    for (let i = 0; i < component.content.value.length; i++) {
                        if (component.content.value[i].key === valueId) {
                            component.content.value[i].checked = value
                        }
                    }
                }
                return changeData.push(component)
            });
        }
        this.setState({data: changeData});
    };

    getIndex = (elementID) => {
        for (let i = 0; i < this.state.data.length; i++) {
            if (this.state.data[i].id === elementID) {
                return i
            }
        }
    };

    getValue = (index, valueId, moreOrLessValue, moreOrLess) => {
        if (moreOrLess === null) {
            let val = this.state.data[index].content.value;
            // console.log("val",val)
            let result = false;
            // console.log("valueId",valueId)
            for (let i = 0; i < val.length; i++) {
                // eslint-disable-next-line no-unused-expressions
                val[i].key === valueId ?
                    result = val[i].checked === true : false
            }
            return result
        } else if (moreOrLess === 'more') {
            let val = this.state.data[index].content.value;
            let result = false;
            for (let i = 0; i < val.length; i++) {
                // eslint-disable-next-line no-unused-expressions
                (parseInt(val[i].item) >= parseInt(moreOrLessValue)) && val[i].checked ?
                    result = true : false
            }
            return result
        } else {
            let val = this.state.data[index].content.value;
            let result = false;
            for (let i = 0; i < val.length; i++) {
                // eslint-disable-next-line no-unused-expressions
                (parseInt(val[i].item) <= parseInt(moreOrLessValue)) && val[i].checked ?
                    result = true : false
            }
            return result
        }
    };

    checkBlockRules = (rule) => {
        let status = null;
        switch (rule.condition) {
            case 'match':
                status = this.getValue(this.getIndex(rule.elementId), rule.valueId, null, null);
                return status;
            case 'does not match':
                status = !this.getValue(this.getIndex(rule.elementId), rule.valueId, null, null);
                return status;
            case 'match or more':
                status = this.getValue(this.getIndex(rule.elementId), rule.valueId, rule.text, 'more');
                return status;
            case 'match or less':
                status = this.getValue(this.getIndex(rule.elementId), rule.valueId, rule.text, 'less');
                // console.log("status",status)
                return status;
        }

    };

    changeStatusData = async (data, item, tempDataResult, valueId, elementId) => {
        for (let j = 0; j < tempDataResult.length; j++) {
            for (let i = 0; i < data[tempDataResult[j]].logicBlock.length; i++) {
                if (data[tempDataResult[j]].logicBlock[i].rules.length > 0) {
                    for (let k = 0; k < data[tempDataResult[j]].logicBlock[i].rules.length; k++) {
                        data[tempDataResult[j]].logicBlock[i].rules[k].status = this.checkBlockRules(data[tempDataResult[j]].logicBlock[i].rules[k])
                    }
                }
            }
        }
        await this.setState({data: data});
    };

    switchRulesMatchType = (block, item) => {
        let status = null;
        switch (block.matchType) {
            case 'all':
                status = block.rules.every(item => item.status === true);
                return status;
            case 'any':
                status = block.rules.some(item => item.status === true);
                return status;
            case 'none':
                status = block.rules.every(item => item.status === false);
                return status
        }
    };

    checkRules = (data, item, tempDataResult, valueId, elementId) => {
        for (let i = 0; i < tempDataResult.length; i++) {
            for (let j = 0; j < data[tempDataResult[i]].logicBlock.length; j++) {
                for (let z = 0; z < data[tempDataResult[i]].logicBlock[j].rules.length; z++) {
                    if (data[tempDataResult[i]].logicBlock[j].rules[z].elementId === elementId) {
                        data[tempDataResult[i]].logicBlock.length > 1 &&
                        console.log('>1! ', data[tempDataResult[i]].logicBlock[j], item)
                        data[tempDataResult[i]].logicBlock[j].status = this.switchRulesMatchType(data[tempDataResult[i]].logicBlock[j], item)
                    }
                }
            }

        }
        this.setState({data: data})
    };

    changeLogicBlockStatus = (data, tempDataResult) => {
        for (let j = 0; j < tempDataResult.length; j++) {
            data[tempDataResult[j]].status = this.checkLogicBlock(tempDataResult[j]);
            data[tempDataResult[j]].visibility = data[tempDataResult[j]].status;
        }
        this.setState({data: data});
        this.forceUpdate()
    };

    checkLogicBlock = (element) => {
        const tData = this.state.data;
        const and = [],
            or = [];
        if (tData[element].logicBlock.length > 1) {
            for (let i = 0; i < tData[element].logicBlock.length; i++) {
                switch (tData[element].logicBlock[i].behavior) {
                    case "and":
                        and.push(tData[element].logicBlock[+i].status === true && tData[element].logicBlock[+i + 1].status === true);
                        break;
                    case "or":
                        if (and.length > 0 && and.includes(true)) {
                            or.push(true)
                        } else {
                            or.push(tData[element].logicBlock[i + 1].status)
                        }
                        break;
                }
            }
            for (let k = 0; k < or.length; k++) {
                if (or[k] === true) return true;
            }
            for (let s = 0; s < and.length; s++) {
                if (and[s] !== true) return false;
            }
            return true;
        } else {
            return tData[element].logicBlock[0].status;
        }
    };

    hiddenElementsStatusHandler = (tData, index) => {
        if (tData[index + 2] !== undefined) {
            for (let j = 0; j < tData[index + 2].logicBlock.length; j++) {
                for (let k = 0; k < tData[index + 2].logicBlock[j].rules.length; k++) {
                    tData[index + 2].logicBlock[j].rules[k].status = false;
                }
            }
        }
        if (tData[index + 3] !== undefined) {
            for (let j = 0; j < tData[index + 3].logicBlock.length; j++) {
                tData[index + 3].logicBlock[j].status = false;
            }
        }
        this.setState({data: tData});
    };

    hideElements = (index) => {
        let tData = this.state.data;
        for (let i = index + 1; i < tData.length; i++) {
            for (let j = 0; j < tData[i].logicBlock.length; j++) {
                this.switchElementsRules(tData[i].logicBlock[j]);
            }
            tData[i].visibility = false;
            tData[i].status = false;
            if (tData[i].content.value !== undefined) {
                for (let j = 0; j < tData[i].content.value.length; j++) {
                    tData[i].content.value[j].checked = false
                }
            }
        }
        this.hiddenElementsStatusHandler(tData, index);
    };

    switchElementsRules = (logicBlock) => {

        switch (logicBlock.matchType) {
            case 'all':
                logicBlock.status = logicBlock.rules.every(item => item.status === true);
                break;
            case 'any':
                logicBlock.status = logicBlock.rules.some(item => item.status === true);
                break;
            case 'none':
                logicBlock.status = logicBlock.rules.every(item => item.status === false);
                break;
        }

        return logicBlock
    };

    checkElementsRulesStatus = (element) => {
        let tData = this.state.data;
        let elemArr = this.state.map[element] ? this.state.map[element].elem : this.state.map[this.state.map.length - 1].elem;
        let elArr = [];

        for (let i = 0; i < elemArr.length; i++) {
            // elemArr[i] === 0 && elArr.push(this.state.map[element].index);
            (elemArr[i] !== undefined & elemArr[i] !== 0) && elArr.push(this.getIndex(elemArr[i]));
        }
        this.state.map.filter(el => el.elem[0] === 0).map(el => elArr.push(el.index))
        // console.log(elArr)
        for (let j = 0; j < elArr.length; j++) {
            for (let k = 0; k < tData[elArr[j]].logicBlock.length; k++) {
                tData[elArr[j]].logicBlock[k] = this.switchElementsRules(tData[elArr[j]].logicBlock[k])
            }
        }

        this.setState({data: tData});
    };

    onClickMultiSelectButton = async (elementId, checkedValue, valueId, item, componentBlock) => {
        this.changeData(elementId, checkedValue, valueId, item, componentBlock);
    };

    changeData = async (elementId, value, valueId, item, componentBlock) => {
        await this.tempDataResultHandler(elementId);
        this.changeCheckedData(elementId, value, valueId, item, componentBlock);
        this.hideElements(this.getIndex(elementId));
        this.changeStatusData(this.state.data, item, this.state.tempDataResult, valueId, elementId, componentBlock);
        this.checkElementsRulesStatus(this.getIndex(elementId));
        this.checkRules(this.state.data, item, this.state.tempDataResult, valueId, elementId);
        this.checkLogicBlock(this.getIndex(elementId));
        this.changeLogicBlockStatus(this.state.data, this.state.tempDataResult);
    };

    render() {
        const {data} = this.state;

        return (
            <div>
                <div>
                    {(data!==undefined && data.length > 0)?
                        data.map(item => (
                            <div key={item.id}>
                                {getComponent(item, this.changeData, this.onClickMultiSelectButton)}
                            </div>
                        ))
                        :
                        <Space style={{marginBottom: 30}}>
                        <Spin size="large" />
                        </Space>
                    }
                </div>
            </div>
        )
    }
}

export default AlgorithmsDetails;
